module.exports = __webpack_public_path__ + "static/media/smartphone.038e6c11.png";